import { ActivitySaleModel } from 'api-hooks/sale/activity';
import { Option } from 'baseui/select';
import { PreferenceFormSchema } from 'common/form-schema';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

export const ActivitySaleAddOnsItemFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    guestId: Yup.string().default(''),
    description: Yup.string().default(''),
    price: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),

    //addional information
    guestName: Yup.string().default(''),
    customId: Yup.string(),
  });

export const ActivitySaleGuestDetailItemFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    activityId: Yup.string().default(''),
    price: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    qty: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    totalPrice: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    description: Yup.string().default(''),
    type: Yup.string().default(''),
    date: Yup.date().default(new Date()),

    //addional information
    activityCode: Yup.string().default(''),
    activityName: Yup.string().default(''),
    customId: Yup.string(),
  });

export const ActivitySaleGuestItemFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    guestId: Yup.string().default(''),
    preferences: Yup.array(PreferenceFormSchema()).default([]),
    activitySaleGuestDetails: Yup.array(
      ActivitySaleGuestDetailItemFormSchema(),
    ).default([]),

    //additional information
    customId: Yup.string(),
    guestName: Yup.string().default(''),
  });

export const ActivitySaleItemFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    isGroupedPrice: Yup.bool().default(false),
    activitySaleGuests: Yup.array(ActivitySaleGuestItemFormSchema()).default(
      [],
    ),
    activitySaleAddOns: Yup.array(ActivitySaleAddOnsItemFormSchema()).default(
      [],
    ),

    //additional information
    customId: Yup.string(),
  });

export const ActivitySaleFormSchema = () =>
  Yup.object({
    refId: Yup.string(),
    parentRefId: Yup.string(),
    transactionAt: Yup.date().default(new Date()),
    needApproval: Yup.boolean().default(false),
    code: Yup.string().default(''),
    description: Yup.string().default(''),
    adminId: Yup.string().default(''),
    operatorId: Yup.string().default(''),
    salesmanId: Yup.string().default(''),
    customerId: Yup.string().default(''),
    customerBillingId: Yup.string().default(''),
    discount: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    otherCost: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    total: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    activitySales: Yup.array(ActivitySaleItemFormSchema()).default([]),

    //additional information
    tempTransactionAt: Yup.date().default(new Date()),
    phone: Yup.string().default(''),
    address: Yup.string().default(''),
    number: Yup.string().default(''),
    customerStatus: Yup.string().default(''),
    hasDueReceivable: Yup.boolean().default(false),
    remainingTransactionQuota: Yup.number().nullable().default(null),
    isExceedingQuota: Yup.boolean().default(false),
  });

export type ActivitySaleGuestItemFormType = Yup.InferType<
  ReturnType<typeof ActivitySaleGuestItemFormSchema>
>;

export type ActivitySaleAddOnsItemFormType = Yup.InferType<
  ReturnType<typeof ActivitySaleAddOnsItemFormSchema>
>;
export type ActivitySalesGuestDetailFormType = Yup.InferType<
  ReturnType<typeof ActivitySaleGuestDetailItemFormSchema>
>;

export type ActivitySaleItemFormType = Yup.InferType<
  ReturnType<typeof ActivitySaleItemFormSchema>
>;

export type ActivitySaleFormType = Yup.InferType<
  ReturnType<typeof ActivitySaleFormSchema>
> & { customerBillingOptions: Option[]; activitySale?: ActivitySaleModel };

export type ActivitySaleMethodType = ReturnType<
  typeof useForm<ActivitySaleFormType>
>;
